import Box from "@material-ui/core/esm/Box";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditButton from 'components/Button/EditButton';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import ProfileItem from '../ProfileItem';
import useStyles from '../ProfileStyles';
import EmailDialog from './EmailDialog';
export default function Email({
  fieldName
}) {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const {
    profileRow,
    actionButton
  } = useStyles();
  const [showDialog, setShowDialog] = useState(false);
  const email = customer ? customer[fieldName] : undefined;
  if (customer && email === undefined) throw new Error(`Field name '${fieldName}' doesn't exist on current customer's object!`);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmailDialog, {
    open: showDialog,
    onClose: () => setShowDialog(!showDialog),
    fieldName: fieldName
  }), /*#__PURE__*/React.createElement("div", {
    className: profileRow
  }, /*#__PURE__*/React.createElement(ProfileItem, {
    label: t('profile.email'),
    value: email
  }), /*#__PURE__*/React.createElement(Box, {
    pb: 0.5
  }, /*#__PURE__*/React.createElement(EditButton, {
    onClick: () => setShowDialog(!showDialog),
    className: actionButton
  }, t('buttons.edit')))));
}